/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener(
  "DOMContentLoaded",
  function load() {
    if (!window.jQuery) return setTimeout(load, 50);
    // get basePrice for product or product bundle
    let basePriceContainer = $("#price, [data-money-convertible]");
    let basePriceText;
    let basePrice;

    // product
    if (basePriceContainer.length > 0) {
      basePriceText =
        basePriceContainer.length > 0 ? basePriceContainer.text() : "";
      basePrice = parseFloat(basePriceText.replace(/[^0-9\-]+/g, ""));
    } else {
      // product bundle with permament sale
      basePriceContainer = $("#basepricesale");
      basePriceText =
        basePriceContainer.length > 0 ? basePriceContainer.text() : "";
      basePrice = parseFloat(basePriceText.replace(/[^0-9\-]+/g, ""));
    }
    console.log("basePrice" + " " + basePrice);

    function changeQuantityEvent(_this, type) {
      const selectQuantitySelector = $('.quantitySelect');
      const radioQuantitySelector = $('.custom-qty');
      const opacityClass = 'dimmed';
      
      if (type === 'radio') {
      	radioQuantitySelector.removeClass(opacityClass)
      	selectQuantitySelector.addClass(opacityClass)
      } else if( type ==='select') {
        selectQuantitySelector.removeClass(opacityClass)
      	radioQuantitySelector.addClass(opacityClass)
      }

      
      // Check if data-money-convertible is added to price container
      if (
        $("[data-money-convertible]").length > 0 &&
        $("[data-money-convertible]").attr("id") !== "price-adjusted"
      ) {
        basePriceContainer = $("[data-money-convertible]");
        basePriceText =
          basePriceContainer.length > 0 ? basePriceContainer.text() : "";
        basePrice = parseFloat(basePriceText.replace(/[^0-9\-]+/g, ""));
        console.log("new basePrice" + " " + basePrice);
      }

      var newVal = parseInt(_this.val());

      // Get current price for selected variant
      var priceText =
        $("#price, [data-money-convertible]").length > 0
          ? $("#price, [data-money-convertible]").text()
          : $("#price-adjusted, [data-money-convertible]").length > 0
          ? $("#price-adjusted, [data-money-convertible]").text()
          : "";
      var price = parseFloat(priceText.replace(/[^0-9\-]+/g, ""));

      // Update base price if reduced price is available
      var compareAtPrice = $(
        ".ProductMeta__Price .Price--compareAt-mengenrabatt .u-h4"
      );
      if (compareAtPrice.length > 0) {
        basePrice = parseFloat(
          compareAtPrice.text().replace(/[^0-9\-]+/g, "")
        );
      }

      // Reset to original price if quantity is 1
      if (newVal === 1 && $("#basepricesale").length == 0) {
        $("#pricecontainermengenrabatt").remove();
        $("#compareAtmengenrabatt").remove();
        $("#prozenzt-mengenrabatt1").remove();
        $("#prozenzt-mengenrabatt").remove();
        $(
          ".ProductMeta__Price__Container .ProductMeta__Price .Text--subdued .u-h4"
        ).text(basePrice.toFixed(2).replace(".", ","));
        $(
          ".ProductMeta__Price__Container .ProductMeta__Price .Price--highlight .u-h4"
        ).text(basePrice.toFixed(2).replace(".", ","));
        if ($("#price-adjusted").length > 0) {
          $("#price-adjusted").attr("id", "price");
        }
        $("#price-adjusted, #price, [data-money-convertible]").html(
          "&euro;" +
            (basePrice / 100).toLocaleString("de-DE", {
              minimumFractionDigits: 2,
            })
        );
        return;
      }
      // console.log("basePrice" + " " + basePrice);
      // Apply discount based on quantity selected
      var discount = 0;
      if (newVal == 2) {
        discount = 0.09;
      } else if (newVal >= 3) {
        discount = 0.12;
      }

      // Update price with discount applied
      var discountedPrice = basePrice * (1 - discount);
      var finalPrice = discountedPrice * newVal;
      var compareprice = (basePrice * newVal) / 100;
      var savePercent = Math.round(
        (1 - finalPrice / (basePrice * newVal)) * 100
      );

      // Update old price and savings percentage
      // var compareAtPriceContainer = $('#pricecontainermengenrabatt');
      // var compareAtPriceContainerSale = $('#basepricesale');
      if (
        $("#pricecontainermengenrabatt").length == 0 &&
        $("#basepricesale").length == 0
      ) {
        compareAtPriceContainer = $(
          '<div class="ProductMeta__Price__Container compareAt-mengenrabatt" id="pricecontainermengenrabatt">' +
            '<span class="ProductMeta__Price Price Price--compareAt-mengenrabatt Text--subdued u-h4" id="compareAtmengenrabatt">' +
            compareprice.toFixed(2).replace(".", ",") +
            "</span>" +
            '<p class="Sparen_Preis" id="prozenzt-mengenrabatt1">du sparst <span class="Sparen_Preis-mengenrabatt" style="color:red;" id="prozenzt-mengenrabatt"></span></p>' +
            "</div>"
        );
      }
      $(".ProductMeta__PriceList .ProductMeta__Price__Container").after(
        compareAtPriceContainer
      );
      compareAtPriceContainer
        .find("#prozenzt-mengenrabatt")
        .html(savePercent + "%");
      compareAtPriceContainer
        .find("#compareAtmengenrabatt")
        .html("&euro;" + compareprice.toFixed(2).replace(".", ","));

      // console.log(savePercent);
      // console.log(compareprice);

      // Update new price
      if (
        $("#price-adjusted, [data-money-convertible]").length > 0 &&
        newVal > 1
      ) {
        $("#price-adjusted, [data-money-convertible]").html(
          "&euro;" + (finalPrice / 100).toFixed(2).replace(".", ",")
        );
      } else if (
        $("#price, [data-money-convertible]").length > 0 &&
        newVal == 1
      ) {
        $("#price, [data-money-convertible]").html(
          "&euro;" + (price / 100).toFixed(2).replace(".", ",")
        );
      } else if (
        $("#price, [data-money-convertible]").length > 0 &&
        newVal > 1
      ) {
        $("#price, [data-money-convertible]").html(
          "&euro;" + (finalPrice / 100).toFixed(2).replace(".", ",")
        );
      } else if (
        $("#price-adjusted, [data-money-convertible]").length > 0 &&
        newVal == 1
      ) {
        $("#price-adjusted, #price, [data-money-convertible]").html(
          "&euro;" + (price / 100).toFixed(2).replace(".", ",")
        );
      }

      // Add price-adjusted ID to price container if it doesn't exist
      if ($("#price-adjusted").length === 0) {
        $("#price, [data-money-convertible]").attr("id", "price-adjusted");
      }
    }
    
    // quantity selector on product page
    $("#quantityCustomSelector").on("change", function()  {
      changeQuantityEvent($(this),'select');
    });
    $("input[name='qtyCtrl']").on("change", function() {
      changeQuantityEvent($(this), 'radio');
    });  
      
    // quantity selector on product bundle page
    $("#quantityCustomSelectorBundle").on("change", function () {
      var newVal = parseInt($(this).val());

      // Get current price for selected variant
      var priceText =
        $("#pricesale, [data-money-convertible]").length > 0
          ? $("#pricesale, [data-money-convertible]").text()
          : $("#price-adjusted, [data-money-convertible]").length > 0
          ? $("#price-adjusted, [data-money-convertible]").text()
          : "";
      var price = parseFloat(priceText.replace(/[^0-9\-]+/g, ""));
      
      // Extract currency symbol from priceText
      var currencySymbol = priceText.replace(/[0-9\.\-,]+/g, "").trim();

      // Convert currency symbol to HTML entity format
      function toHtmlEntity(currencySymbol) {
        switch (currencySymbol) {
          case "€":
            return "&euro;";
          case "$":
            return "&dollar;";
          case "£":
            return "&pound;";
          default:
            return currencySymbol;
        }
      }

      currencySymbol = toHtmlEntity(currencySymbol);
      
      const discountText = $(".Sparen_Preis span").text();
      const discount =
        parseFloat(discountText.replace(/[^0-9\-]+/g, "")) / 100;

      // // Update price with discount applied
      var discountedPrice = basePrice * (1 - discount);
      var finalPrice = discountedPrice.toFixed(0) * newVal;

      // Choose the correct locale for the currency
      var locale = "de-DE"; // default to German format
      if (currencySymbol === "&dollar;") {
        locale = "en-US";
      } else if (currencySymbol === "&pound;") {
        locale = "en-GB";
      }

      $("#pricesale").html(
        currencySymbol +
          (finalPrice / 100).toLocaleString(locale, {
            minimumFractionDigits: 2,
          })
      );

      $("#basepricesale").html(
        currencySymbol +
          ((basePrice * newVal) / 100).toLocaleString(locale, {
            minimumFractionDigits: 2,
          })
      );
    });

    function updateQty(val) {
      $("input[name='quantity']").val(val);
    }

    // Shipping info based on price of selected variant
    const freeShippingTextContainer = jQuery(
      "body.template-product .Product__Info .items .item .free"
    );
    const paidShippingTextContainer = jQuery(
      "body.template-product .Product__Info .items .item .paid"
    );
    const initialShippingTextContainer = jQuery(
      "body.template-product .Product__Info .items .item .initial"
    );

    const underPriceContainerFree = jQuery(
      ".Product__Info div form .ProductMeta__Text"
    ).eq(0);
    const underPriceContainerPaid = jQuery(
      ".Product__Info div form .ProductMeta__Text"
    ).eq(1);

    // Shipping initial info
    const price = jQuery("#price").text().replace(/\D/g, "");
    if (price >= 3000) {
      underPriceContainerFree.show();
      underPriceContainerPaid.hide();
    } else {
      underPriceContainerFree.hide();
      underPriceContainerPaid.show();
    }

    document.addEventListener("variant:changed", function (event) {
      //  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      //    bubbles: true
      // }));
      
      let variant = event.detail.variant; // Gives you access to the whole variant details
      initialShippingTextContainer.hide();
      if (variant.price >= 3000) {
        // Free shipping
        freeShippingTextContainer.show();
        paidShippingTextContainer.hide();
        underPriceContainerFree.show();
        underPriceContainerPaid.hide();
      } else {
        freeShippingTextContainer.hide();
        paidShippingTextContainer.show();
        underPriceContainerFree.hide();
        underPriceContainerPaid.show();
      }

      // reset megne select
      if ($("#quantityCustomSelector").length > 0) {
        $("#quantityCustomSelector").prop("selectedIndex", 0);
      }

      if ($("#quantityCustomSelectorBundle").length > 0) {
        $("#quantityCustomSelectorBundle").prop("selectedIndex", 0);
      }
    });

    function updateCartCount() {
      var cartContents = fetch(window.Shopify.routes.root + "cart.js")
        .then((response) => response.json())
        .then((data) => {
          return data;
        });
    }

    const quantityChanger = $('[data-action="update-item-quantity"]');
    quantityChanger.on("click", function () {
      updateCartCount();
    });

    const quantitySelector = $(".QuantitySelector__CurrentQuantity");
    quantityChanger.on("change", function () {
      updateCartCount();
    });

    document.addEventListener("product:added", function (event) {
      updateCartCount();
    });

    document.addEventListener("cart:refresh", function (event) {
      console.log("Cart refresh");
    });

    // Fix lazy load images
    function waitForElm(selector) {
      return new Promise((resolve) => {
        if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver((mutations) => {
          if (document.querySelector(selector)) {
            resolve(document.querySelector(selector));
            observer.disconnect();
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      });
    }

    waitForElm(".Product__Gallery .Image--lazyLoaded").then((elm) => {
      setTimeout(() => {
        const images = document.querySelectorAll(
          ".Product__Gallery .Image--lazyLoaded"
        );
        for (let i = 0; i < images.length; i++) {
          images[i].classList.add("Image--lazyLoad");
        }
      }, 1);
    });


    // Klavyio out of stock trigger
    document.querySelector('.klaviyo-bis-trigger').addEventListener('click', function (){
		window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'SVdrDW']);
	});
    
  },
  false
);

    document.addEventListener('DOMContentLoaded', function () {
    const variantSelect = document.getElementById('variant-select');
    const deliveryTime = document.getElementById('delivery-time');

    // Funktion, um das Metafield zu aktualisieren
    const updateDeliveryTime = () => {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      const deliveryTimeValue = selectedOption.getAttribute('data-delivery-time');

      if (deliveryTimeValue) {
        deliveryTime.textContent = deliveryTimeValue;
      } else {
        deliveryTime.textContent = 'unbekannt';
      }
    };

    // Event-Listener für Variantenwechsel
    variantSelect.addEventListener('change', updateDeliveryTime);

    // Initiale Anzeige beim Laden der Seite
    updateDeliveryTime();
  });


